const article = {
    slug: "first_comme_des_garcons_experience",
    category: "BRAND ENTRY",
    title: "初めてのCOMME des GARCONS｜コムデギャルソンをEnclopediaでレンタル体験",
    listDescription:
      "難しそうに見えるギャルソンを、“買う前に着る”ことで知るための入口ページ。",
    seo: {
      title:
        "初めてのCOMME des GARCONS｜コムデギャルソンをレンタル体験｜気軽に着て知るEnclopedia",
      description:
        "COMME des GARCONS｜コムデギャルソンが気になるけれど、何から見ればいいか分からない方へ。ブランドの魅力、主要ラインの違い、初めて着ると分かることを解説し、Enclopediaでレンタルできるコムデギャルソンのアーカイブへ案内します。",
      keyword:
        "初めてのコムデギャルソン,コムデギャルソン 初めて,コムデギャルソン どんなブランド,コムデギャルソン 着てみたい,コムデギャルソン レンタル,COMME des GARCONS レンタル,コムデギャルソン オムプリュス,enclopedia,アンクロペディア",
      canonicalPath: "/archive_guide/first_comme_des_garcons_experience",
    },
    hero: {
      label: "FIRST COMME DES GARÇONS EXPERIENCE",
      number: "01 / ENTRY",
      titleLines: ["初めての", "COMME des GARÇONSをレンタル体験。"],
      body:
        "難しそうに見えるコムデギャルソンを、\n“買う前に着る”ことで知るための入口ページです。\nブランドの魅力、ラインの違い、初めて着たときに分かることを整理しながら、Enclopediaで体験できるアーカイブへつなげます。",
      keywords: [
        "first experience",
        "archive",
        "wear before own",
        "comme des garçons",
      ],
      visualLabel: "ARCHIVE EXPERIENCE",
      visualTitle: ["気になっていた服を、", "まず着て理解する。"],
      image: "media/archive_fashion/archive_guide1.png",
      imageAlt: "初めてのCOMME des GARÇONSをレンタル体験するためのアーカイブガイド画像",
      ctaLabel: "レンタルできるコムデギャルソンを見る",
      ctaHref: "https://www.enclopedia-official.com/brand/COMME%20DES%20GARCONS（コムデギャルソン）/?number=10",
    },
    thesis: {
      text:
        "ギャルソンは、知ってから着る服ではなく、着ることで見え方が変わる服でもあります。",
      keywords: ["entry", "experience", "understanding"],
    },
    sections: {
      whyThisPage: {
        label: "02 / WHY THIS PAGE?",
        titleLines: [
          "コムデギャルソンが気になる。",
          "でも、何から見ればいいか分からない。",
        ],
        body:
          "COMME des GARÇONSは、服を“分かりやすく消費する”ブランドではありません。\nだからこそ、初めて触れる人には少し遠く見えることがあります。\nこのページでは、ブランドを難解な知識としてではなく、“着ることで理解が始まる文化”として整理します。",
      },
      brandOverview: {
        label: "03 / BRAND OVERVIEW",
        titleLines: ["“難しいブランド”ではなく、", "見方を変えるブランド。"],
        body:
          "コムデギャルソンは、既存の美しさや服の“普通”を問い直してきたブランドです。\n黒、非対称、解体、膨らみ、余白。\n目立つ装飾だけではなく、服の構造そのものを更新する姿勢に大きな特徴があります。",
        knowledgeItems: [
          {
            title: "美しさを、別の角度から見る。",
            text:
              "端正さだけではなく、歪みや余白、未完成に見える形の中にも価値を見出す。ギャルソンは“なぜ美しいのか”を服で問い続けます。",
          },
          {
            title: "服より先に、身体の見え方を変える。",
            text:
              "服が身体を整えるのではなく、服が身体の輪郭や存在感を組み替える。その感覚は、実際に着ると最も分かりやすく立ち上がります。",
          },
          {
            title: "アーカイブで評価される理由。",
            text:
              "一過性のトレンドではなく、コレクションごとに問いがあり、時間が経っても読み直せる。だから過去作品が資料として残ります。",
          },
          {
            title: "初心者ほど、“着てみる”意味がある。",
            text:
              "写真で難しく見える服ほど、身体に乗せると印象が変わることがあります。最初の理解をレンタルが補助します。",
          },
        ],
      },
      lineGuide: {
        label: "04 / WHICH LINE?",
        titleLines: [
          "“コムデギャルソン”は一つではない。",
          "初めてなら、入口の違いを知る。",
        ],
        items: [
          {
            tag: "ENTRY 01",
            title: "COMME des GARÇONS",
            text:
              "ブランドの中核。既存の美しさや服の“普通”を問い直す姿勢が最も濃く表れます。",
          },
          {
            tag: "ENTRY 02",
            title: "COMME des GARÇONS HOMME PLUS",
            text:
              "メンズにおける実験の中心。テーラリング、身体、装飾を大胆に再構成します。",
          },
          {
            tag: "ENTRY 03",
            title: "COMME des GARÇONS HOMME DEUX",
            text:
              "日本の背広,日常に近いスーツやジャケットの中で、ギャルソンらしい緊張感を体験しやすいラインです。",
          },
          {
            tag: "ENTRY 04",
            title: "COMME des GARÇONS SHIRT / COMME des GARÇONS COMME des GARÇONS",
            text:
              "より軽やかな入口。日常着に近い距離で、ギャルソンの発想に触れられます。",
          },
        ],
      },
      firstExperience: {
        label: "05 / FIRST EXPERIENCE",
        titleLines: ["初めて着ると、", "何が分かるのか。"],
        intro:
          "ギャルソンの魅力は、説明を読むだけでは完結しません。身体に乗せた瞬間に初めて分かる“服との距離感”があります。",
        items: [
          {
            index: "01",
            title: "“黒い服”の奥にある違い",
            text:
              "黒を基調にしていても、素材の厚み、切替、襟の角度、分量感によって印象は大きく変わります。ギャルソンは色よりも構造で服を記憶に残します。",
          },
          {
            index: "02",
            title: "身体を整えるより、見え方を更新する",
            text:
              "一般的な服が身体を美しく整えるために働くのに対し、ギャルソンは身体の輪郭や存在感そのものを問い直すことがあります。",
          },
          {
            index: "03",
            title: "違和感は、難しさではなく入口になる",
            text:
              "最初は“少し変わっている”と感じる服でも、その違和感がどこから来るかを知ると、見方が変わります。",
          },
        ],
      },
      quote: {
        textLines: [
          "所有の前に、体験する。",
          "そのほうが、ギャルソンはずっと近くなる。",
        ],
      },
      whyRent: {
        label: "06 / WHY RENT?",
        titleLines: ["初めてのギャルソンほど、", "レンタルと相性がいい。"],
        items: [
          {
            number: "01",
            title: "写真だけでは分からない",
            text:
              "サイズ表よりも、身体に乗せたときの重心や空気感で印象が変わる。まず着ることで、理解の解像度が上がります。",
          },
          {
            number: "02",
            title: "違和感が入口になる",
            text:
              "少し難しく見える服でも、その違和感がどこから来るかを知ると、魅力に変わります。",
          },
          {
            number: "03",
            title: "所有前の判断材料になる",
            text:
              "高額なアーカイブほど、素材感や生活との距離を確かめたうえで選ぶ体験が重要です。",
          },
        ],
      },
      inventory: {
        label: "07 / AVAILABLE ARCHIVE",
        titleLines: ["Enclopediaで", "体験できる一着。"],
        body:
          "実在庫への導線は、“ブランド説明の続き”として設計します。読むだけで終わらず、気になった服をそのまま体験へ進めます。",
        items: [
          {
            meta: "COMME des GARÇONS",
            title: "Archive Item 01",
            text:
              "初めてのコムデギャルソン体験につながる、実物で確かめたいアーカイブアイテム。",
            href: "https://www.enclopedia-official.com/product/ee262ae8-20a8-4065-b227-e5d392176a03",
            image:
              "media/product/1727876263.9000912ee262ae8-20a8-4065-b227-e5d392176a03.jpg",
          },
          {
            meta: "COMME des GARÇONS",
            title: "Archive Item 02",
            text:
              "写真だけでは分かりにくいシルエットや素材感を、レンタルで体験できる一着。",
            href: "https://www.enclopedia-official.com/product/6d4e73e7-6ae8-4bc1-bbac-69a855493a72",
            image:
              "media/product/1755779605.73427256d4e73e7-6ae8-4bc1-bbac-69a855493a72.jpg",
          },
          {
            meta: "COMME des GARÇONS",
            title: "Archive Item 03",
            text:
              "ブランドらしい違和感や構造を、最初の一着として試しやすいアーカイブ。",
            href: "https://www.enclopedia-official.com/product/25b45365-050d-4281-9ad0-536f21f0fc99",
            image:
              "media/product/1758033139.971845925b45365-050d-4281-9ad0-536f21f0fc99.jpg",
          },
          {
            meta: "COMME des GARÇONS",
            title: "Archive Item 04",
            text:
              "詳細ページで状態やサイズを確認しながら、レンタル体験へ進めるアーカイブ。",
            href: "https://www.enclopedia-official.com/product/23d8dac3-41aa-42d7-8d6e-1fa68ab20251",
            image: "media/product/1776929485.797350423d8dac3-41aa-42d7-8d6e-1fa68ab20251.png",
          },
        ],
      },
      faq: {
        label: "08 / FAQ",
        titleLines: ["初めての人が、", "気になりやすいこと。"],
        items: [
          {
            question: "初めてでも、いきなりレンタルして大丈夫ですか？",
            answer:
              "大丈夫です。Enclopediaは、アーカイブに詳しい人だけでなく、“気になっているが、まだ着たことがない人”の入口として設計しています。",
          },
          {
            question: "コムデギャルソンは難しそうで、自分に合うか不安です。",
            answer:
              "その不安こそ、体験が役立つ部分です。写真や寸法だけでは分からない相性を、まず着て確かめられます。",
          },
          {
            question: "どのラインから見るのがおすすめですか？",
            answer:
              "日常との距離が近いHOMME DEUXやSHIRT、より強い体験を求めるならCOMME des GARCONS HOMME PLUSがおすすめです。",
          },
          {
            question: "レンタル後に購入もできますか？",
            answer:
              "対象アイテムは、レンタル体験を経たうえで購入相談へ進める導線を想定しています。",
          },
        ],
      },
      finalCta: {
        titleLines: [
          "初めてのコムデギャルソンを、",
          "レンタルから始める。",
        ],
        body:
          "難しそうに見える服ほど、実際に着ることで距離が縮まります。\nEnclopediaで、気になっていた一着を体験してください。",
        buttonLabel: "レンタルできるコムデギャルソンを見る",
        buttonHref: "https://www.enclopedia-official.com/brand/COMME%20DES%20GARCONS（コムデギャルソン）/?number=10",
      },
    },
  };

export default article;
